module.exports = __webpack_public_path__ + "static/media/logo.75936a36.svg";